import script from "./SoftwarePage.vue?vue&type=script&setup=true&lang=js"
export * from "./SoftwarePage.vue?vue&type=script&setup=true&lang=js"

import "./SoftwarePage.vue?vue&type=style&index=0&id=6eb1e938&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6eb1e938"]])

export default __exports__